// extracted by css-extract-rspack-plugin
export default {"Heading":"no-data-card-module__Heading__HEmTI3A","Box":"no-data-card-module__Box__YhqSGFH"};